export function publicUrl() {
  return process.env.PUBLIC_URL;
}

export function imageUrl(path) {
  return `${publicUrl()}/assets/images/${path}`;
}

export function baseUrl() {
  return process.env.REACT_APP_BASE_URL;
}

export function absoluteUrl(path) {
  return `${baseUrl()}/${path}`;
}

export function buyeeUrl(path) {
  return `${process.env.REACT_APP_BUYEE_BASE_URL}/${path}`;
}
